import apiClient from "./api";
const COTIZACIONESESTUDIOS_API_BASE_URL = "/cotizacionesEstudios";
class CotizacionesEstudiosService {
 
  async getEstudiosPorCotizacion(cotizacionId) {
    try {
      const response = await apiClient.get(
        `${COTIZACIONESESTUDIOS_API_BASE_URL}/cotizacion/${cotizacionId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

}
export default new CotizacionesEstudiosService();
